import { Link } from "react-router-dom";
import { formatDate, mediaUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const OverlayCard = ({ article: a, size = "sm", label, testId }) => {
  const { catName } = useSettings();
  return (
  <Link to={`/article/${a.slug}`} data-testid={testId} className={`group relative block overflow-hidden bg-zinc-800 ${size === "lg" ? "aspect-[16/10] lg:h-[460px] lg:aspect-auto" : "aspect-[16/10]"}`}>
    {a.image_url && <img src={mediaUrl(a.image_url)} alt={a.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
    <div className={`absolute left-0 right-0 bottom-0 ${size === "lg" ? "p-6 md:p-8" : "p-4"}`}>
      <div className="flex gap-1.5 mb-2">
        {label && <span className="badge-cat bg-[#111827]">{label}</span>}
        <span className="badge-cat">{catName(a.category)}</span>
      </div>
      <h3 className={`font-heading font-extrabold text-white leading-tight ${size === "lg" ? "text-2xl md:text-4xl" : "text-base line-clamp-2"} group-hover:text-red-400 transition-colors`}>{a.title}</h3>
      {size === "lg" && a.excerpt && <p className="text-zinc-200 text-sm md:text-base mt-3 line-clamp-2 max-w-2xl">{a.excerpt}</p>}
      <div className="meta text-zinc-300 mt-2"><span>{formatDate(a.published_at)}</span><span>/</span><span>{a.author}</span></div>
    </div>
  </Link>
  );
};
